import { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { authCheck } from '../../api/auth/auth'
import { token } from '../../api/auth/auth'
import jwt from 'jsonwebtoken'

import Loader from '../../components/Loader'
import { UserContext } from '../../contexts/UserContext'

const Home = () => {
  const router = useHistory()
  const { user, setUser } = useContext(UserContext)
  const userData = jwt.decode(token())

  setUser({ ...user, ...userData })
  // console.log(userData)

  useEffect(() => {
    authCheck(() => router.push('/meu-perfil'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div>
      <Loader />
    </div>
  )
}
export default Home
